import { Link } from 'react-router-dom';
import MVCard from '@/components/base/MVCard';
import type { MVItem } from '@/mocks/mvs';

interface MVSectionProps {
  title: string;
  subtitle?: string;
  mvs: MVItem[];
  viewAllLink?: string;
  viewAllLabel?: string;
  variant?: 'grid' | 'featured';
}

export default function MVSection({ title, subtitle, mvs, viewAllLink, viewAllLabel, variant = 'grid' }: MVSectionProps) {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              {title}
            </h2>
            {subtitle && (
              <p className="text-sm md:text-base text-foreground-500 mt-2">{subtitle}</p>
            )}
          </div>
          {viewAllLink && (
            <Link
              to={viewAllLink}
              className="flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              {viewAllLabel || '查看全部'}
              <i className="ri-arrow-right-line"></i>
            </Link>
          )}
        </div>

        {variant === 'featured' && mvs.length > 0 && (
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 md:gap-5 mb-4">
            <div className="lg:col-span-3">
              <MVCard mv={mvs[0]} size="large" />
            </div>
            <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4 md:gap-5">
              {mvs.slice(1, 3).map((mv) => (
                <MVCard key={mv.id} mv={mv} size="small" />
              ))}
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {(variant === 'featured' ? mvs.slice(3) : mvs).map((mv) => (
            <MVCard key={mv.id} mv={mv} />
          ))}
        </div>
      </div>
    </section>
  );
}